import axios from 'axios';
import store from '../store';
import nprogress from 'nprogress';

const http = axios.create();

nprogress.configure({
  minimum: 0.1,
  showSpinner: false,
  trickleRate: 0.02
})

http.interceptors.request.use(config => {
  if (store.state.isProgressBar) nprogress.inc();

  return config;
}, error => {
  if (store.state.isProgressBar) nprogress.done();
  return Promise.reject(error);
});

http.interceptors.response.use(response => {
  if (store.state.isProgressBar) nprogress.done();
  return response;
}, error => {
  if (store.state.isProgressBar) nprogress.done();
  return Promise.reject(error);
});

export default http;